import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

// Animated counter that extracts the numeric portion of a value like "+14%" or "+8.000"
export function Counter({ value, duration = 1800 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!inView) return;
    const match = String(value).match(/([+-]?)([\d.,]+)(.*)/);
    if (!match) {
      setDisplay(value);
      return;
    }
    const prefix = match[1];
    const numStr = match[2];
    const suffix = match[3] || "";
    const isDecimal = numStr.includes(",");
    const normalized = parseFloat(numStr.replace(/\./g, "").replace(",", "."));
    if (isNaN(normalized)) {
      setDisplay(value);
      return;
    }
    let raf;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const current = normalized * eased;
      let formatted;
      if (normalized >= 1000) {
        formatted = Math.round(current).toLocaleString("it-IT");
      } else if (isDecimal) {
        formatted = current.toFixed(1).replace(".", ",");
      } else {
        formatted = Math.round(current).toString();
      }
      setDisplay(`${prefix}${formatted}${suffix}`);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration]);

  return <span ref={ref}>{display}</span>;
}
